export default function Footer() {
  return (
    <footer className="relative bg-brand-green text-brand-bone pt-20 md:pt-28 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="relative max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start pb-12 border-b border-brand-gold/20">
          <div className="md:col-span-7">
            <h4 className="font-light leading-[1.05] tracking-[-0.02em] text-3xl md:text-4xl lg:text-5xl">
              Elevate every threshold.
              <span className="block text-brand-gold">One door at a time.</span>
            </h4>
            <p className="mt-5 text-brand-bone/70 max-w-lg font-light leading-relaxed">
              Timeless style. Modern performance. Made for life — the Atelier Door Collection by
              ViewLux.
            </p>
          </div>
          <div className="md:col-span-5 grid grid-cols-2 gap-8">
            <div>
              <div className="text-[0.62rem] tracking-[0.28em] uppercase text-brand-gold mb-3 font-medium">
                Collection
              </div>
              <ul className="space-y-2 text-brand-bone/85 font-light">
                <li><a href="#exterior" className="hover:text-brand-gold">Exterior</a></li>
                <li><a href="#interior" className="hover:text-brand-gold">Interior</a></li>
                <li><a href="#garage" className="hover:text-brand-gold">Garage</a></li>
                <li><a href="#finishes" className="hover:text-brand-gold">Finishes</a></li>
              </ul>
            </div>
            <div>
              <div className="text-[0.62rem] tracking-[0.28em] uppercase text-brand-gold mb-3 font-medium">
                Contact
              </div>
              <ul className="space-y-2 text-brand-bone/85 font-light">
                <li>
                  <a href="tel:8777171555" className="hover:text-brand-gold" data-testid="footer-phone">
                    877-717-1555
                  </a>
                </li>
                <li>
                  <a href="mailto:Info@Viewluxwindows.com" className="hover:text-brand-gold [overflow-wrap:anywhere]" data-testid="footer-email">
                    Info@Viewluxwindows.com
                  </a>
                </li>
                <li>By appointment only</li>
                <li><a href="/admin/login" className="hover:text-brand-gold" data-testid="footer-admin-link">Dealer Portal</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Showrooms */}
        <div className="pt-12 pb-8 border-b border-brand-gold/20" data-testid="footer-showrooms">
          <div className="text-[0.62rem] tracking-[0.28em] uppercase text-brand-gold mb-6 font-medium">
            Visit A Showroom
          </div>
          <p className="text-brand-bone/70 font-light mb-6 max-w-2xl">
            Can be seen at the ViewLux Windows and Doors showroom locations —
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                state: "California",
                locations: [
                  { city: "Los Angeles", addr: "7061 Vineland Ave #1/2, North Hollywood, CA 91605" },
                  { city: "Santa Clara", addr: "1800 Wyatt Dr S 3, Santa Clara, CA 95054" },
                ],
              },
              {
                state: "Colorado",
                locations: [
                  { city: "Denver", addr: "8245 E I-25 Frontage Rd #2, Frederick, CO 80515" },
                ],
              },
              {
                state: "Nevada",
                locations: [
                  { city: "Las Vegas", addr: "3720 W Oquendo Rd, Suite 104, Las Vegas, NV 89118" },
                ],
              },
            ].map((s) => (
              <div key={s.state} data-testid={`showroom-${s.state.toLowerCase()}`}>
                <div className="text-brand-gold text-sm tracking-[0.16em] uppercase font-medium">
                  {s.state}
                </div>
                <ul className="mt-3 space-y-4">
                  {s.locations.map((loc) => (
                    <li key={loc.city}>
                      <div className="text-brand-bone text-base md:text-lg font-light tracking-[-0.01em]">
                        {loc.city}
                      </div>
                      <p className="text-brand-bone/65 text-xs font-light leading-snug mt-1 max-w-[16rem]">
                        {loc.addr}
                      </p>
                      <a
                        href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(loc.addr)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1.5 mt-2 text-[0.62rem] tracking-[0.24em] uppercase text-brand-gold hover:text-brand-bone transition"
                        data-testid={`showroom-map-${loc.city.replace(/\W+/g, "-").toLowerCase()}`}
                      >
                        Get Directions
                        <span aria-hidden>↗</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 mt-10">
          <div>
            <div className="text-[0.6rem] tracking-[0.28em] uppercase text-brand-bone/60">
              © {new Date().getFullYear()} · Atelier Door Collection
            </div>
            <div className="text-[0.6rem] tracking-[0.28em] uppercase text-brand-bone/60 mt-1">
              By ViewLux · European Craftsmanship
            </div>
          </div>
          <img
            src="/atelier-logo.png"
            alt="Atelier Door Collection by ViewLux"
            className="h-10 md:h-12 w-auto opacity-90"
            draggable={false}
          />
        </div>
      </div>
    </footer>
  );
}
